<template>
  <div class="lsjl-box">
    <div class="lsjl-top">
      <div class="lsjl-tabs">
        <div 
          :class="tabIndex === index ? 'lsjl-tab-active' : 'lsjl-tab'" 
          v-for="(item, index) in tabs" 
          :key="index" 
          @click="handleTabChange(index)"
        >
          {{item.name}}
        </div>
      </div>
      <div class="lsjl-date">
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          range-separator="-"
          :start-placeholder="$t('all.kaishiriqi')"
          :end-placeholder="$t('all.jieshuriqi')"
          value-format="yyyy-MM-dd"
          @change="handleDateChange"
          :picker-options="pickerOptions"
		  
        ></el-date-picker>
      </div>
    </div>
    <div class="lsjl-table">
      <div class="lsjl-table-header">
        <span class="lsjl-table-col lsjl-col-date">{{$t('all.riqi')}}</span>
        <span class="lsjl-table-col lsjl-col-type">{{$t('all.leixing')}}</span>
		<span class="lsjl-table-col lsjl-col-type">{{$t('all.miaoshu')}}</span>
        <span class="lsjl-table-col lsjl-col-amount">{{$t('all.jine')}}</span>
        <!-- <span class="lsjl-table-col lsjl-col-status">{{$t('all.zhuangtai')}}</span> -->
      </div>
      <div class="lsjl-table-body" ref="listContainer" @scroll="handleScroll" v-if="list.length > 0">
        <div class="lsjl-table-row" v-for="(item, index) in list" :key="index">
          <span class="lsjl-table-col lsjl-col-date">{{item.createTime}}</span>
          <span class="lsjl-table-col lsjl-col-type">{{item.billTypeName}}</span>
		  <span class="lsjl-table-col lsjl-col-type">{{item.billDesc}}</span>
          <span class="lsjl-table-col lsjl-col-amount" :class="item.amount > 0 ? 'lsjl-amount-green' : 'lsjl-amount-red'">
            {{item.amount > 0 ? '+' : ''}}{{item.amount}} {{item.unitText}}
          </span>
          <!-- <span class="lsjl-table-col lsjl-col-status">
            <span v-if="item.status === 1" class="lsjl-status-done">{{$t('all.yiwancheng')}}</span>
            <span v-else class="lsjl-status-pending">{{$t('all.shenhezhong')}}</span>
          </span> -->
        </div>
        <!-- <div class="lsjl-loading" v-if="isLoading">
          {{$t('all.jiazaihong')}}
        </div> -->
      </div>
      <div class="lsjl-table-empty" v-else>
        {{$t('all.zanwushuju')}}
      </div>
    </div>
  </div>
</template>

<script>
import { getWalletBillTypeEnums,getWalletBalanceBillList } from "@/api/qianbao";
export default {
  data() {
    return {
      tabIndex: 0,
      tabs: [],
      dateRange: null,
      list: [],
      unitText: 'NB',
      hasMore: true,
      isLoading: false,
      queryParams: {
        page: 1,
        size: 20,
        type: 0,
		currencyId:this.$route.query.currencyId
      },
      pickerOptions: {}
    };
  },
  mounted() {
	this.getWalletBillTypeEnums()
    this.unitText = this.$route.query.unitText || 'NB';
    this.getList();
  },
  methods: {
	async getWalletBillTypeEnums(){
	  const res = await getWalletBillTypeEnums()
	  this.tabs = res.data
	},
    handleTabChange(index) {
      this.tabIndex = index;
      this.queryParams.billType = this.tabs[index].type;
      this.queryParams.page = 1;
      this.hasMore = true;
      this.getList();
    },
    handleDateChange(val) {
      if (val) {
        this.queryParams.startDate = val[0];
        this.queryParams.endDate = val[1];
      } else {
        this.queryParams.startDate = '';
        this.queryParams.endDate = '';
      }
      this.queryParams.page = 1;
      this.hasMore = true;
      this.getList();
    },
    async getList() {
      if (this.isLoading || !this.hasMore) {
        return;
      }

      try {
        this.isLoading = true;
        const res = await getWalletBalanceBillList(this.queryParams);
        const newList = res.rows || res.data || [];

        if (this.queryParams.page === 1) {
          this.list = newList;
        } else {
          this.list = [...this.list, ...newList];
        }

        const totalPages = Math.ceil((res.total || 0) / this.queryParams.size);
        this.hasMore = this.queryParams.page < totalPages;
      } catch (error) {
        console.error("获取流水记录失败:", error);
      } finally {
        this.isLoading = false;
      }
    },
    handleScroll() {
      if (this.isLoading || !this.hasMore) {
        return;
      }

      const container = this.$refs.listContainer;
      const isAtBottom = container.scrollTop + container.clientHeight >= container.scrollHeight - 50;

      if (isAtBottom) {
        this.queryParams.page++;
        this.getList();
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "./liushuijilu.css";

/deep/ .el-date-editor {
	background: rgba(255, 255, 255, 0.1) !important;
	border: none !important;
	border-radius: 38px !important;
	width: 360px !important;
}
/deep/ .el-date-editor .el-range-input {
	background: transparent !important;
	color: #FFFFFF !important;
}
/deep/ .el-date-editor .el-range-separator {
	color: rgba(255, 255, 255, 0.6) !important;
}
/deep/ .el-date-editor .el-range__icon {
	color: rgba(255, 255, 255, 0.6) !important;
}
/deep/ .el-date-editor .el-range__close-icon {
	color: rgba(255, 255, 255, 0.6) !important;
}
</style>
<style>
	.el-range-input{
		background: rgba(255,255,255,0.01);
		color: #ffffff;
	}
	.el-input__icon .el-range__close-icon{
		color: #ffffff;
	}
</style>


// WEBPACK FOOTER //
// liushuijilu.vue?63897a1e